import { config } from '../config';
class APIClient {
    constructor() {
        this.baseUrl = config.bankApiUrl;
    }
    async fetch(endpoint, options = {}) {
        const url = `${this.baseUrl}${endpoint}`;
        const response = await fetch(url, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': config.bankApiKey,
                ...options.headers,
            },
        });
        return response.json();
    }
}
export const apiClient = new APIClient();
